<template>
    <div id="page-not-found" class="vh-100 d-flex flex-column">
    	<div class="container h-100 d-flex justify-content-center">
    		<div class="align-self-center">
				<h1><b>404</b> {{ $t('error_page.404_title') }}</h1>
				<a href="/">{{ $t('error_page.404_btn_back') }}</a>
			</div>
    	</div>
		<footer-text></footer-text>
    </div>
</template>

<script>
import Header from '../components/Header.vue'
export default {
    // mounted() {
    // }
}
</script>